import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IEditCheck } from 'starbase-launcher';

@Injectable({
    providedIn: 'root'
})
export class SaveFormGuardService implements CanDeactivate<IEditCheck> {

    constructor() { }

    public canDeactivate(component: IEditCheck): Observable<boolean> | boolean {
        const b = component.unsavedChangesCheck();
        if (typeof (b) === 'boolean') {
            return b;
        } else {
            return b.pipe(map(a => a));
        }
    }
}
